import { Button, UIHeading1, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './CommonCPDLandingBanner.css';
import { NBSP } from 'shared/constants/symbols';

interface ICommonCPDLandingBannerProps {
  onClick: () => void;
}

export const CommonCPDLandingBanner: React.FC<ICommonCPDLandingBannerProps> = ({ onClick }) => {
  const handleButtonClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      onClick();
    },
    [onClick],
  );

  return (
    <section className={styles['container']} data-testid="CommonCPDLandingBanner" onClick={onClick}>
      <UIHeading1>Бесплатно подберём и{NBSP}поможем купить любое жильё</UIHeading1>
      <div className={styles['description-wrapper']}>
        <UIText1>
          Под{NBSP}сдачу, у{NBSP}работы,{NBSP}для{NBSP}жизни за{NBSP}городом
        </UIText1>
      </div>
      <div>
        <Button onClick={handleButtonClick}>О сервисе</Button>
      </div>
    </section>
  );
};
